import Image from 'next/image';
import { getImageBasePath } from 'utils/generics';

import * as Styles from './styles';

const GSTLoading = () => {
    return (
        <Styles.Wrapper>
            <Styles.TextWrapper>
                <Styles.Text>
                    Hang tight - we&apos;re checking your GST with govt
                    database...
                </Styles.Text>
                <Styles.LoaderWrapper>
                    <Image
                        src={getImageBasePath('/gif/pageLoader.gif')}
                        alt=""
                        width={80}
                        height={80}
                    />
                </Styles.LoaderWrapper>
            </Styles.TextWrapper>
        </Styles.Wrapper>
    );
};

export default GSTLoading;
